<p-toast />
<p-toast key="action" />
<p-confirmDialog />

<!-- Unsaved-changes confirmation (opened by unsavedChangesGuard). Lives in the
     root because the guard is shared by several routes (wizard, my-account,
     company form). -->
<p-confirmdialog key="unsaved-changes" data-testid="app-dialog-unsaved-changes">
  <ng-template #header>
    <span class="p-dialog-title">
      <i class="ta-icon-edit" aria-hidden="true"></i>
      <ng-container i18n="@@unsaved_changes_header">Unsaved Changes</ng-container>
    </span>
  </ng-template>
</p-confirmdialog>

<router-outlet />
